import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  box: {
    padding: "10px 15px",
    paddingLeft: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: "transparent",
  },
  root: {
    backgroundColor: "transparent",
    minHeight: "unset",
  },
  flexContainer: {
    gap: "15px",
  },
  indicator: {
    display: "none",
  },
  tab: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    textTransform: "none",
    padding: "5px",
    height: "31px",
    borderRadius: "5px",
    minHeight: "unset",
    minWidth: "unset",
    background: "#EAE9E9",
    color: "#272525",
    transition: "all 0.3s ease",
  },
  selectedTab: {
    background: "#4D127733",
    color: "#4D1277",
    borderRadius: "5px",
    padding: "5px",
    gap: "10px",
  },
  unselectedTab: {
    backgroundColor: "#EAE9E9",
    color: "#272525",
  },
  saveText: {
    fontWeight: 400,
    fontSize: "13px",
  },
  annualLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  },
}));

export default useStyles;
